import { getAuthToken } from "./authSession";

// Short-lived, per-tab cache of the first page of list screens (shops, products).
// The cached page is shown instantly on open while the fresh list is fetched in the background.
const TTL_MS = 5 * 60 * 1000;

const cacheKey = (namespace, url) => {
  const token = getAuthToken() || "";
  // Keep only a tail of the token so one visitor's list is not shown to another in the same tab.
  return `${namespace}:${token.slice(-16)}:${url}`;
};

const readListCache = (namespace, field, url) => {
  if (!url || typeof window === "undefined") {
    return null;
  }

  try {
    const key = cacheKey(namespace, url);
    const raw = sessionStorage.getItem(key);
    if (!raw) {
      return null;
    }

    const parsed = JSON.parse(raw);
    if (!parsed?.ts || Date.now() - parsed.ts > TTL_MS || !Array.isArray(parsed.data?.[field])) {
      sessionStorage.removeItem(key);
      return null;
    }

    return parsed.data;
  } catch {
    return null;
  }
};

const writeListCache = (namespace, field, url, data) => {
  if (!url || !data || !Array.isArray(data[field]) || typeof window === "undefined") {
    return;
  }

  try {
    sessionStorage.setItem(
      cacheKey(namespace, url),
      JSON.stringify({
        ts: Date.now(),
        data,
      })
    );
  } catch {
    // ignore quota errors
  }
};

export const readShopListCache = (url) => readListCache("visitor_shop_list_cache", "shops", url);

export const writeShopListCache = (url, data) =>
  writeListCache("visitor_shop_list_cache", "shops", url, data);

export const readProductListCache = (url) =>
  readListCache("visitor_product_list_cache", "products", url);

export const writeProductListCache = (url, data) =>
  writeListCache("visitor_product_list_cache", "products", url, data);
